import React from "react";
import ATLTinkerpreneurCTA from "./ATLTinkerpreneurCTA";

const ATLTinkerpreneurBanner = (props) => {
  const { year } = props;
  return (
    <div className="d-flex align-items-center flex-column">
      <img
        src={`/images/tinkerpreneur-${year}-banner.jpeg`}
        className="w-100"
        alt={`Tinkerpreneur ${year} banner`}
      />
      <ATLTinkerpreneurCTA year={year} />
    </div>
  );
};

export default ATLTinkerpreneurBanner;
